import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', function() {

    let sliders = [];

    const carousels = document.querySelectorAll('.carousel');

    initCarousels(carousels);

    window.addEventListener('resize', manageResize);
    
    function initCarousels(carousels) {
        if ( window.innerWidth <= 768 ) {

            [...carousels].forEach( carousel => {

                const wrapper = carousel.querySelector('.wp-block-post-template');
                wrapper.classList.add('swiper-wrapper');

                sliders.push( activateCarousel(carousel) );
            });

        }
    }

    function activateCarousel(carousel) {
        const swiper = new Swiper( carousel, {
            loop: true,
            modules: [Navigation, Pagination],
            slideClass: 'wp-block-post',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
        return swiper;
    }

    function manageResize() {
        if ( window.innerWidth <= 768 ) {
            initCarousels(carousels);
        } else {
            sliders.forEach( slider => {
                slider.destroy();
            });
        }
    }
});